// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___9957643fdb8f2e1e062{/*!*/}.Unibrow-cls2__bceed68d1d111ee48e71{display:flex;align-items:center;grid-gap:16px;gap:16px;grid-gap:var(--spacing-xs-16, 16px);gap:var(--spacing-xs-16, 16px)}@media(max-width: 567px){.Unibrow-cls2__bceed68d1d111ee48e71{grid-gap:10px;gap:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___9957643fdb8f2e1e062",
	"cls2": "Unibrow-cls2__bceed68d1d111ee48e71 Unibrow-cls1___9957643fdb8f2e1e062"
};
export default ___CSS_LOADER_EXPORT___;
